// 
// > Caution: adding .rwd-desktop CSS class for limiting processing to an 992px min window size

var fn_sticky = function () {
  var header = $('.rwd-desktop .header__wrapper')
  var headerHeight = $('.rwd-desktop .header__wrapper').outerHeight();

  $(window).scroll(function () {
    scrollPos = $(window).scrollTop()

    if (scrollPos > (headerHeight*1.5)) {
      header.addClass('is-sticky')
    }else {
      header.removeClass('is-sticky')
    }
  })
}

var fn_header_move_up = function () {
  // SOURCE : http://jsfiddle.net/mariusc23/s6mLJ/31/

  // Hide Header on on scroll down
  var didScroll
  var lastScrollTop = 0
  var delta = 5
  var navbarHeight = $('.header__wrapper').outerHeight()

  $(window).scroll(function (event) {
    didScroll = true
  })

  setInterval(function () {
    if (didScroll) {
      hasScrolled()
      didScroll = false
    }
  }, 250)

  function hasScrolled () {
    var st = $(this).scrollTop()

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
      return

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $('.rwd-desktop .header__wrapper').addClass('is-moving-up')

      // Closing Meganav while moving for we may have just a meganav stuck onto the screen...
      $('.rwd-desktop .header__wrapper .dropdown-menu.show').dropdown('toggle')
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $('.header__wrapper').removeClass('is-moving-up')
      }
    }

    lastScrollTop = st
  }
}
